import {FreeGamesData} from '@fantasmagames/slot/src/logic/integration/FreeGamesData';
import {IRecodeBet, RecodeIntegrator} from '@fantasmagames/slot/src/integration/RecodeIntegrator';

export interface SavedData {
	spinData: any;
	isFS: boolean;
}

export class RecodeFakeCommunicator extends RecodeIntegrator {

	protected _savedInit: any;
	protected _savedSpins: SavedData[] = [];

	protected _fakeResponses: string[] = [];
	protected _fakeFSResponses: string[] = [];
	protected _fakeInit: string;

	public addFakeFSResponse(response: string): void {
		this._fakeFSResponses.push(response);
	}

	public addFakeResponse(response: string): void {
		this._fakeResponses.push(response);
	}

	public addInitFake(response: string): void {
		this._fakeInit = response;
	}

	public init(gameID: string, callback: Function): void {
		if (this._fakeInit) {
			setTimeout(() => {
				callback(JSON.parse(this._fakeInit));
				this._fakeInit = '';
			}, 100);
		} else {
			super.init(gameID, (jsonData: any) => {
				callback(jsonData);
				this._savedInit = jsonData;
			});
		}
	}

	public spin(gameID: string, sessionID: string, totalBet: IRecodeBet, callback: Function, freeRoundsData?: FreeGamesData): void {
		if (this._fakeResponses.length > 0) {
			setTimeout(() => {
				callback(JSON.parse(this._fakeResponses[0]));
				this._fakeResponses.splice(0, 1);
			}, 100);
		} else {
			super.spin(gameID, sessionID, totalBet, (jsonData: any) => {
				callback(jsonData);
				this._savedSpins.push({spinData: jsonData, isFS: false});
			}, freeRoundsData);
		}
	}

	public freespin(callback: Function): void {
		if (this._fakeFSResponses.length > 0) {
			setTimeout(() => {
				callback(JSON.parse(this._fakeFSResponses[0]));
				this._fakeFSResponses.splice(0, 1);
			}, 100);
		} else {
			super.freespin((jsonData: any) => {
				callback(jsonData);
				this._savedSpins.push({spinData: jsonData, isFS: true});
			});
		}
	}

	public pick(chestIndex: number, callback: Function, callbackObj: any, freeRoundsData?: FreeGamesData): void {
		if (this._fakeResponses.length > 0) {
			setTimeout(() => {
				callback(JSON.parse(this._fakeResponses[0]));
				this._fakeResponses.splice(0, 1);
			}, 100);
		} else {
			super.pick(chestIndex, callback, callbackObj, freeRoundsData);
		}
	}

	public skippick(chestIndex: number, callback: Function, callbackObj: any, freeRoundsData?: FreeGamesData): void {
		if (this._fakeResponses.length > 0) {
			setTimeout(() => {
				callback(JSON.parse(this._fakeResponses[0]));
				this._fakeResponses.splice(0, 1);
			}, 100);
		} else {
			super.skippick(chestIndex, callback, callbackObj, freeRoundsData);
		}
	}

	public openChest(chestIndex: number, callback: Function, callbackObj: any, freeRoundsData?: FreeGamesData): void {
		if (this._fakeResponses.length > 0) {
			setTimeout(() => {
				callback(JSON.parse(this._fakeResponses[0]));
				this._fakeResponses.splice(0, 1);
			}, 100);
		} else {
			super.openChest(chestIndex, callback, callbackObj, freeRoundsData);
		}
	}

	public createSavedStuffFakes(): void {
		let finalText: string = '';
		if (this._savedInit) {
			finalText += `communicator.addInitFake('${JSON.stringify(this._savedInit)}');\n`;
		}
		for (const response of this._savedSpins) {
			if (response.isFS) {
				finalText += `communicator.addFakeFSResponse('${JSON.stringify(response.spinData)}');\n`;
			} else {
				finalText += `communicator.addFakeResponse('${JSON.stringify(response.spinData)}');\n`;
			}
		}

		console.log(finalText);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/integration/RecodeFakeCommunicator.ts